<template>
  <sidebar-right @overlayClicked="outside" :class="[
    'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720',
    { open: show }
  ]">
   
    <div class="tab-content borderRadius-3" v-if="(step==1)">
        <!-- Card header -->
        <div class="card-header d-flex align-items-center" :class="{
          'blue-class': $route.name == 'projects',
          'green-class': $route.name == 'tasks.home',
          'yellow-class': $route.name == 'timesheet.home'
        }">
          <!-- Title -->
          <!-- <div class="col px-0">
          <h4 class="h3 mb-0">{{project.name}}</h4>
            <h5 v-if="currentProject && currentProject.payment_status!='SUCCESS'">Payment Status: <span  style="color:red" class="error" >({{ currentProject.payment_status.replace("_"," ")  }})</span></h5>
            <span  style="color:red" class="error" v-if="currentProject && currentProject.financePayer && currentProject.payment_status != 'SUCCESS'">{{(currentProject.financePayer.user.id == profile.id)?"You are":currentProject.financePayer.user.first_name + ' is'}}  the Finance Administrator of this project.</span>
        </div> -->
          <h4 class="h3 mb-0 mt-1">
            Update Card Details <span class="right-bracket position-relative d-inline-block" style="top:-2px">{</span>
          </h4>
        </div>
      
      
      <div id="payBills" role="tabpanel" class="col-sm-12 tab-pane fade active show">

        
        <div class="card card-body" v-if="paymentInfo.billingDetails && paymentMode == 'card'">
          
          <div class="row">
            <div class="col-sm-8">
              <label>Current Card has billing issues, please update below</label>
              <h2>{{ paymentInfo.billingDetails.cc_number }}</h2>
            </div>
            
          </div>
        </div>

        <div class="card card-body" v-if="(paymentMode == 'card' && editMode)">
          <!-- <h3 class="mb-2">Card Details </h3> -->
          <div class="row" v-if="
                            (paymentMode == 'card' && paymentInfo.billingDetails == null) ||
          (paymentMode == 'card' && editMode)">
            <div class="col-sm-6 form-group">
              <label>Card Holder Name</label>
              <input v-model="form.rebillCC.name" type="text" class="form-control" placeholder="Enter Full Name" />

              <span v-if="
                $v.form.rebillCC && $v.form.rebillCC.name && $v.form.rebillCC.name.$error
              " class="error field">
                Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Card Number</label>
              <input v-model="form.rebillCC.number" type="card" class="form-control" name="card"
                placeholder="Enter credit card no..." />
              <span v-if="
                $v.form.rebillCC && $v.form.rebillCC.number &&
                  $v.form.rebillCC.number.$error
              " class="error field">
                Card number is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>CVC</label>
              <input v-model="form.rebillCC.cvc" type="number" class="form-control" name="cvc" placeholder="" />
              <span v-if="$v.form.rebillCC && $v.form.rebillCC.cvc && $v.form.rebillCC.cvc.$error" class="error field">
                required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Expiry</label>
              <div class="d-flex">
                <input v-model="form.rebillCC.exp_month" type="text" class="form-control col-md-6 mr-1"
                  placeholder="MM" />
                <input v-model="form.rebillCC.exp_year" type="text" class="form-control col-md-6" placeholder="YY" />
              </div>
              <span v-if="
                ($v.form.rebillCC && $v.form.rebillCC.exp_year &&
                  $v.form.rebillCC.exp_year.$error) ||
                  ($v.form.rebillCC.exp_month &&
                    $v.form.rebillCC.exp_month.$error)
              " class="error field">
                required
              </span>
            </div>

            <div class="col-sm-12 d-flex flex-row justify-content-end" v-if="false">
             

              <base-checkbox v-model="form.saveCard" class="mt-1"></base-checkbox>
              <span class="ml-2">
                Save Card details for future
              </span>
            </div>
          </div>

          <hr />
          <!-- <h3 class="mb-2">Billing Details </h3> -->
          <div class="row" v-if="
            (paymentMode == 'card' &&
              paymentInfo.billingDetails == null) ||
              editMode
          ">
            <div class="col-sm-6 form-group">
              <label>First Name</label>
              <input v-model="form.customer.first_name" type="text" class="form-control"
                placeholder="Enter First Name" />
              <span v-if="
                $v.form.customer.first_name &&
                  $v.form.customer.first_name.$error
              " class="error field">
                First Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Last Name</label>
              <input v-model="form.customer.last_name" type="text" class="form-control" placeholder="Last Name" />
              <span v-if="
                $v.form.customer.last_name &&
                  $v.form.customer.last_name.$error
              " class="error field">
                Last Name is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Email</label>
              <input v-model="form.customer.email" type="text" class="form-control" placeholder="Enter Full Name" />

              <span v-if="
                $v.form.customer.email && $v.form.customer.email.$error
              " class="error field">
                Email is required
              </span>
            </div>

            <div class="col-sm-6 form-group">
              <label>Street</label>
              <input v-model="form.customer.address_street" type="text" class="form-control"
                placeholder="Enter Full Name" />
            </div>

            <div class="col-sm-6 form-group">
              <label>City</label>
              <input v-model="form.customer.suburb" type="text" class="form-control" placeholder="Enter City" />
            </div>

            <div class="col-sm-6 form-group">
              <label>Zip</label>
              <input v-model="form.customer.zip" type="text" class="form-control" placeholder="Enter Zip" />
            </div>

            <div class="col-sm-6 form-group">
              <label>State</label>
              <input v-model="form.customer.state" type="text" class="form-control" placeholder="Enter State" />
            </div>

            <div class="col-sm-6 form-group">
              <label>Country</label>

              <el-select v-model="form.customer.country" class="select-danger w-100" placeholder="Select Country"
                value-key="code">
                <el-option v-for="option in [
                  { name: 'Australia', code: 'AU' },
                  { name: 'United States', code: 'US' },
                  { name: 'United Kingdom', code: 'GB' },
                  { name: 'Nepal', code: 'NP' }
                ]" :value="option" :label="option.name" :key="option.code" class="select-danger" />
              </el-select>
            </div>
          </div>
        </div>


      </div>

      <div class="row">
        <div class="col-md-6 p-4">
          <button class="btn  btn-success btn-block" @click="_onUpdateCardClicked">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Update Now
            </span>
          </button>
        </div>

        <div class="col-md-6 p-4">
          <button class="btn  btn-danger btn-block" @click="step=1">
            <span class="icon-sml">
              <i class="fas fa-pay"></i>
              Cancel
            </span>
          </button>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>

<script>
import swal from "sweetalert2";
import { VueAvatar } from "vue-avatar-editor-improved";
import "sweetalert2/dist/sweetalert2.css";
import { mapState, mapActions, mapMutations } from "vuex";
import Modal from "@/components/Modal";
import AssignCompany from "@/app/components/AssignCompany.vue";
import axios from "axios";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import numeral from 'numeral'
import moment from 'moment'
const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {})

export default {
  name: "CardUpdate",
  props: ["show", "fullWidth", "project"],
  components: {
    VueAvatar,
    AssignCompany,
    UserPicker,
    SidebarRight
  },

  data() {
    return {
      step:1,
      form: {
        customer: {},
        rebillCC: {},
        saveCard: true

      },
      
      showCurrency: true,
      paymentMode: "card",
      paymentInfo: {},
      editMode: true, //later will use profile.hasCard
     

      selects: {
        showCurrency: "",
        currency: [
          { value: "USD", label: "United states", symbol: "$" },
          { value: "AUD", label: "Australia", symbol: "$" },
          { value: "EUR", label: "Euro", symbol: "€" },
          { value: "GBP", label: "Pound Sterling", symbol: "£" },
          { value: "CAD", label: "Canada", symbol: "$" }
        ]
      },
    };
  },

  validations: {
    form: {
      customer: {
        first_name: {
          required
        }
      },
      rebillCC: {
        name: {
          required
        },
        number: {
          required
        },
        cvc: {
          required
        },
        exp_month: {
          required
        },
        exp_year: {
          required
        }
      }
    }
  },


  computed: {
    ...mapState("user", ["profile", "banners"]),
     
    ...mapState("common", ["countries"]),

    
    


    
  },

  watch: {
    show(newval, oldval) {
      
    }
  },

  mounted() {
    numeral.defaultFormat('0,0');
    

    console.log("data recurring dates", this.recurringAmounts)
    this.$nextTick(async () => {
      await this.fetchPayment();

      this.form = {
        ...this.form,
        customer: { ...this.profile, image: null, user_preference: null }
      };

      if (this.currentProject) {
        this.userInvite = this.currentProject.financePayer;
      }
    });
  },

  methods: {
    ...mapActions("user", [
      "savePreference",
      "updateProfileInfo",
      "deleteBanner",
      "saveBanner",
      "fetchBanners"
    ]),
    ...mapActions("project", [
      "invitePayersToProject",
      "fetchPaymentInfo",
      "updatePayement"
    ]),

    






    async _onUpdateCardClicked() {
      if (this.editMode) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return false;
        }

        try {
          const body = {
            ...this.form,
            project: this.project,
            mode: this.paymentMode,
          };
          console.log("Body", body)

          // ==================
          let res = await this.updatePayement(body);
          this.$snack.success(res.message);
          this.fetchPayment();
          this.$emit("updateSuccess");
          // ==================

        } catch (e) {
          console.log(e, "error occured")
          this.$snack.success(
            e.response.data.message || "Error creating payment"
          );
        }
      } 
    },

    async fetchPayment() {
      try {
        let res = await this.fetchPaymentInfo(this.project.id);
        this.paymentInfo = res;
      } catch (e) {
        console.log("eeeeee", e);
        this.$snack.success(
          e.response.data.title || "Error fetching payment info"
        );
      }
    },

    outside() {
      localStorage.setItem('approvalTasks', null)
      this.$emit("outSideClicked");
    }
  }
};
</script>

<style lang="scss">
.el-input input.el-input__inner {
  border-radius: 5px;
}

h4 span.right-bracket {
  color: #fddf43;
}
</style>
